export const housingTypes = ['house', 'apartment', 'terrain', 'parking', 'loft'] as const;
export const advertiserTypes = ['isPrivateAdvertiser', 'realEstateTradesAdvertiser'] as const;
export const oldOrNewTypes = ['newProperty', 'oldProperty'] as const;
export const furnishedUnfurnished = ['furnished', 'unfurnished'] as const;
